<template>
  <div v-if="pageContent">
    <default-layout :nav-bar-variant="pageContent.NavBarVariant">
      <content-block-list :blocks="pageContent.body" />
    </default-layout>
  </div>
</template>

<script>
import ContentBlockList from '@/components/ContentBlockList'
import DefaultLayout from '@/layouts/Default'
import loader from '@/build-tools/loaders/poetix-cms-loader'

export default {
  components: { DefaultLayout, ContentBlockList },
  data () {
    return { pageContent: null, story: null }
  },
  metaInfo () {
    return {
      title: `Poetix - ${this.pageContent ? this.pageContent.title : ''}`,
      meta : [
        { name: 'description', content: `${this.pageContent ? this.pageContent.description : ''}` },
        { property: 'og:title', content: `Poetix - ${this.pageContent ? this.pageContent.title : ''}` },
        { property: 'og:site_name', content: 'Poetix' },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: `${this.pageContent ? `${this.pageContent.image.filename}/m/1920x1080/smart` : ''}` },
        { name: 'robots', content: 'index,follow' },
      ],
    }
  },
  watch: {
    $route () {
      this.initPage()
    },
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      this.story = await loader.getStory(`${this.$route.path.slice(1)}`).catch(() => {
        this.$router.replace('404')
      })
      if (!this.story.content || await this.$storyblokHelper.isInStoryblokEditor()) {
        this.setRouteEventsDefaults(this.story.content)
        this.$storyblokHelper.getContentUpdates(this.story, (updatedContent) => {
          this.pageContent = updatedContent
          this.setRouteEventsDefaults(updatedContent)
        }).catch(() => {
          this.$router.replace('404')
        })
      } else
        this.pageContent = this.story.content
    },
    setRouteEventsDefaults (content) {
      if (this.$analytics && content) {
        this.$analytics.setRouteEventsDefaults(
          this.$route.path,
          content.analyticsEventDefaults,
        )
      }
    },
  },
}
</script>
